import { toasterMsg } from '../../../../../Components/Toaster/Toaster';
import t from './SupplierToDo.type';
import * as SupplierToDo from '../../../../../services/supplierToDo.services';

export const saveToDoConfigData = (data, t) => async () => {
  try {
    const res = await SupplierToDo.saveSupplierConfigData(data);
    if (res?.code === 200) {
      const msg = t(`SUPPLIER_TO_DO.${res.message}`);
      toasterMsg(msg, 'success');
    } else {
      toasterMsg(res.data.errMsg, 'danger');
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getSupplierConfigData = (pramams) => async (dispatch) => {
  try {
    const res = await SupplierToDo.getSupplierConfigData(pramams);
    if (res?.code === 200) {
      await dispatch({
        type: t.SET_SUPPLIER_CONFIG_DATA,
        payload: res.data,
      });
      return true;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getSupplierDataByDevId = (pramams) => async (dispatch) => {
  try {
    const res = await SupplierToDo.getSupplierDetailData(pramams);
    if (res?.code === 200) {
      await dispatch({
        type: t.SET_SUPPLIER_DETAIL_DATA,
        payload: res.data,
      });
      return true;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getSupplierTodoList = (pramams) => async (dispatch) => {
  try {
    const requestId = pramams.requestId || Date.now().toString();
    const res = await SupplierToDo.getSupplierTodoListService(pramams);
    if (res?.code === 200) {
      await dispatch({
        type: t.SET_SUPPLIER_REQUESTS_TODOLIST,
        payload: {
          data: res.data.doc,
          totalCount: res.data.totalCount,
          searchText: pramams.searchText,
          isScrolled: pramams.isScrolled,
          requestId,
        },
      });
      return res.data.doc;
    }
    return res?.data;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const filterSortData = (obj) => async (dispatch) => {
  try {
    await dispatch({
      type: t.SET_SUPPLIER_FILTER_SORT_DATA,
      payload: obj,
    });
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const saveDetailConfigData = (data, t) => async () => {
  try {
    const res = await SupplierToDo.saveSupplierDetailData(data);
    if (res?.code === 200) {
      const msg = t(`SUPPLIER_TO_DO.${res.message}`);
      toasterMsg(msg, 'success');

      return res;
    }
    toasterMsg(res.data.errMsg, 'danger');

    return res;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getAllComponentSubTypeWithoutBomType = () => async (dispatch) => {
  try {
    const res = await SupplierToDo.getAllComponentSubType();

    if (res?.code === 200) {
      await dispatch({
        type: t.GET_COMPONENT_TYPE,
        payload: res.data,
      });
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};
